module.exports = __webpack_public_path__ + "static/media/sprite@2x.caf23d0d.png";